<template>
  <div :style="{height:height+'px',zIndex:zIndex}" @click="handleClick">
    <div :class="[className, active ? 'fixed': '']" :style="{left: isFull ? 0 : '', top: 0 +'px',zIndex:zIndex,position:position,width: isFull ? '100%' : width,height:height+'px'}">
      <slot>
        <div>sticky</div>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'zr-sticky',
  props: {
    stickyTop: {
      type: Number,
      default: 0
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    className: {
      type: String
    },
    clickToTop: {
      type: Boolean,
      default: false
    },
    isFull: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false,
      position: '',
      currentTop: '',
      width: undefined,
      height: undefined,
      child: null,
      stickyHeight: 0,
      originScrollTop: 0
    };
  },
  methods: {
    sticky() {
      if (this.active) {
        return;
      }
      this.position = 'fixed';
      this.active = true;
      this.width = this.width + 'px';
      this.$emit('change', true);
    },
    reset() {
      if (!this.active) {
        return;
      }
      this.position = '';
      this.width = 'auto';
      this.active = false;
      this.$emit('change', false);
    },
    handleScroll() {
      this.width = this.$el.getBoundingClientRect().width;
      const offsetTop = this.$el.getBoundingClientRect().top;
      if (offsetTop <= this.stickyTop) {
        this.sticky();
        return;
      }
      this.reset();
    },
    handleClick(ev) {
      if (this.clickToTop && this.active) {
        this.scrollToTop(this.originScrollTop);
      }
    }
  },
  mounted() {
    this.height = this.$el.getBoundingClientRect().height;
    this.originScrollTop = this.$el.getBoundingClientRect().top;
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  scrollToTop(target = 0, min) {
    const body = document.body;
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    if (min && scrollTop < min) return;

    const top = () => {
      scrollTop = scrollTop + -scrollTop / 6;
      if (scrollTop < target + 1) {
        body.scrollTop = target;
        return;
      }
      body.scrollTop = document.documentElement.scrollTop = scrollTop;
      requestAnimationFrame(top);
    };
    top();
  }
};
</script>